import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class GlobalVariable {
	_zipCode: string = ''
	_offerId!: string

	get zipCode(): any {
		return this._zipCode
	}
	set zipCode(value: any) {
		this._zipCode = value
	}

	get offerId(): any {
		return this._offerId
	}
	set offerId(value: any) {
		this._offerId = value
	}

}
